export default "__VITE_ASSET__B6hq7KFh__"